import React from 'react';

interface IosActivityRingProps {
  elapsedSeconds: number;
  thresholdSeconds?: number;
  size?: number;
  strokeWidth?: number;
}

export function IosActivityRing({
  elapsedSeconds,
  thresholdSeconds = 120,
  size = 36,
  strokeWidth = 3.5,
}: IosActivityRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  // Percentage from 0 to 1, can exceed 1 (capped for visual arc at 1.0)
  const progressRatio = Math.min(1, Math.max(0, elapsedSeconds / thresholdSeconds));
  const strokeDashoffset = circumference - progressRatio * circumference;

  const isOverThreshold = elapsedSeconds >= thresholdSeconds;

  return (
    <div
      className="relative flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        className="transform -rotate-90"
        viewBox={`0 0 ${size} ${size}`}
      >
        {/* Track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="rgba(245, 158, 11, 0.15)"
          strokeWidth={strokeWidth}
          fill="none"
        />

        {/* Progress Arc */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={isOverThreshold ? '#EF4444' : '#F59E0B'}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          fill="none"
          style={{
            transition: 'stroke-dashoffset 900ms cubic-bezier(0.32, 0.72, 0, 1), stroke 400ms ease',
          }}
        />
      </svg>

      {/* Center status beacon */}
      <span
        className={`absolute w-1.5 h-1.5 rounded-full ${
          isOverThreshold ? 'bg-rose-400 animate-ping' : 'bg-amber-400 animate-pulse'
        }`}
      />
    </div>
  );
}
